import styled from 'styled-components';
import { generateSpacing } from 'styles/spaces';

export const FilterNameWrapper = styled.div`
  margin-bottom: ${generateSpacing(10)};
`;
